export const lovableReplitGuide = {
  slug: 'choose-build-lovable-replit-app',
  title: 'How to choose and build with Lovable or Replit',
  date: '2026-10-05',
  description: 'Lovable or Replit? Choose a starting tool, then build one useful workflow. Check saved data, sign-in, account access, payments and the published app.',
};
